/** One neutral loading view for session verification and workspace restoration. */
export function WorkspaceLoading() {
  return (
    <div
      role="status"
      className="flex h-full items-center justify-center bg-bg text-sm text-fg-faint"
    >
      Opening workspace…
    </div>
  );
}
